import ArrowWithBg from '../../assets/svg/ArrowWithBg'
import Battery from '../../assets/svg/Battery'
import CardSettings from '../../assets/svg/CardSettings'
import Controls from '../../assets/svg/Controls'
import empower from '../../assets/svg/empower'
import InsightsBg from '../../assets/svg/InisghtsBg'
import JioIcon from '../../assets/svg/JioIcon'
import Lock from '../../assets/svg/Lock'
import MobileCard from '../../assets/svg/MobileCard'
import MobileCardBg from '../../assets/svg/MobileCardBg'
import { MultiLanguage } from '../../assets/svg/MultiLanguage'
import Offer from '../../assets/svg/Offer'
import OfferCampaign from '../../assets/svg/OfferCampaign'
import PaymentModes from '../../assets/svg/PaymentModes'
import ProductsBg from '../../assets/svg/ProductsBg'
import QrBg from '../../assets/svg/QrBg'
import RefundsBg from '../../assets/svg/RefundsBg'
import Settings from '../../assets/svg/settings'
import Settlements from '../../assets/svg/Settlements'
import SettlementsBg from '../../assets/svg/SettlementsBg'
import Sim from '../../assets/svg/Sim'
import Star from '../../assets/svg/Star'
import Templates from '../../assets/svg/Templates'
import VaultTokensBg from '../../assets/svg/VaultTokensBg'

const bgCollect1 = require('../../assets/svg/link-bg.svg')
const bgCollect2 = require('../../assets/svg/invoice-bg.svg')
const bgCollect3 = require('../../assets/svg/setting-bg.svg')
const lpDirectImage = require('../../assets/images/individual-product/direct/direct.png')
const bgDirect1 = require('../../assets/svg/seamless_experience_bg.svg')
const bgDirect2 = require('../../assets/svg/trending_up_bg.svg')
const bgDirect3 = require('../../assets/svg/firewall_bg.svg')
const bgRepeatlp = require('../../assets/images/individual-product/repeat/repeat.png')
const mobile = require('../../assets/images/individual-product/checkout/mobile.png')
const mobChTop3 = require('../../assets/svg/integration-bg.svg')

const directPayment = require('../../assets/images/individual-product/direct/payment.png')
const checkoutHeaderImg = require('../../assets/images/individual-product/checkout/checkout-header.png')
const vaultHeaderImg = require('../../assets/images/individual-product/vault/vault-header.png')
const collectHeaderImg = require('../../assets/images/individual-product/collect/collect-header.png')
const repeatHeader = require('../../assets/images/individual-product/repeat/repeat-header.png')
const campaignHeader = require('../../assets/images/individual-product/campaign/campaign-header.png')
const consoleHeader = require('../../assets/images/individual-product/console/console-header.png')
const qrHeader = require('../../assets/images/upiHub.png')
const voiceBoxHeader = require('../../assets/images/voicebox.png')

export const sectionData: any = {
  paydirect: {
    id: 'Direct',
    header: 'Payments. Your app. Your way.',
    subHeader: 'Collect payments seamlessly and increase conversions',
    headerImage: directPayment,
    stats: [
      {
        id: 0,
        icon: 'FUND_TRANSFER',
        title: '300 Million+',
        subTitle: 'Transactions processed',
      },
      {
        id: 1,
        icon: 'SHOP',
        title: '100K+',
        subTitle: 'Unique merchants',
      },
      {
        id: 2,
        icon: 'TOKEN',
        title: '7 Million+',
        subTitle: 'Cards tokenized',
      },
    ],
    checkListheader: 'Get paid online instantly',
    checkList: {
      leftColumn: [
        {
          id: '1',
          component: Lock,
          title: 'Safe and secure transactions',
          bg: ['#E6DBFF', '#FFE8F9'],
        },
        {
          id: '2',
          imgUrl: require('../../assets/svg/easy_integration.svg'),
          title: 'Easy API integration',
          bg: ['#D9FFE7', '#D5F1FF'],
        },
        {
          id: '3',
          imgUrl: require('../../assets/svg/mobile-desktop.svg'),
          title: 'Comprehensive support',
          bg: ['#FFDEE2', '#FFEFF1'],
        },
      ],
      rightColumn: [
        {
          id: '1',
          imgUrl: require('../../assets/svg/innovate_at_scale.svg'),
          title: 'Innovate at scale',
          bg: ['#BCD4FF', '#D9F5FF'],
        },
        {
          id: '2',
          component: PaymentModes,
          title: 'Popular payment modes',
          bg: ['#FFF8EF', '#FFDBD0'],
        },
        {
          id: '2',
          imgUrl: require('../../assets/svg/trending_up.svg'),
          title: 'Increase conversion',
          bg: ['#F5EFC9', '#FFFFE2'],
        },
      ],
    },
    lpImage: lpDirectImage,
    contentMap2: [
      {
        imageTop: bgDirect1,
        header: 'Offer your users a seamless experience',
        subHeader:
          'Create a custom experience to create a payment experience that is as unique as your product or use our UI for faster payment acceptance',
        buttonText: 'Simplify Experience',
        uri: 'experience',
      },
      {
        imageTop: bgDirect2,
        header: 'Increase your business by converting better',
        subHeader:
          'Be it using our APIs or our out of the box product, accept all payments in one single, simple integration',
        buttonText: 'Simplify Experience',
        uri: 'experience',
      },
      {
        imageTop: bgDirect3,
        header: 'Scale business without compromising security',
        subHeader:
          'Multiplying your business should not come at the cost of security. Build on the trust customers have in you with our state of the art security',
        buttonText: 'Secure Payments',
        uri: 'secure',
      },
    ],
    advantage:
      'Increase conversion rate by solving for your digital payment acceptance needs with either a ready-to-use or a API based payment gateway.',
    idealFor: 'Any business wanting to accept digital payments from their users with minimal effort.',
  },
  payrepeat: {
    id: 'Repeat',
    header: 'Invoice. Collect. Repeat.',
    subHeader: 'Bill your customers on time, every time and increase lifetime value',
    headerImage: repeatHeader,
    isFullWidth: true,
    stats: [
      {
        id: 0,
        icon: 'FUND_TRANSFER',
        title: '300 Million+',
        subTitle: 'Transactions processed',
      },
      {
        id: 1,
        icon: 'SHOP',
        title: '100K+',
        subTitle: 'Unique merchants',
      },
      {
        id: 2,
        icon: 'TOKEN',
        title: '7 Million+',
        subTitle: 'Cards tokenized',
      },
    ],
    checkListheader: 'Automate repeat payments of your users',
    checkList: {
      leftColumn: [
        {
          id: '1',
          icon: 'REFUNDS',
          title: 'Automatic payments',
          bg: ['#E6DBFF', '#FFE8F9'],
        },
        {
          id: '2',
          icon: 'SMILE',
          title: 'Delightful experience',
          bg: ['#D9FFE7', '#D5F1FF'],
        },
        {
          id: '3',
          imgUrl: require('../../assets/svg/mitigate_risk.svg'),
          title: 'Mitigate risk',
          bg: ['#FFDEE2', '#FFEFF1'],
        },
      ],
      rightColumn: [
        {
          id: '1',
          component: MobileCard,
          title: 'Collect from cards & UPI',
          bg: ['#BCD4FF', '#D9F5FF'],
        },
        {
          id: '2',
          imgUrl: require('../../assets/svg/easy_integration.svg'),
          title: 'Simple integration',
          bg: ['#FFF8EF', '#FFDBD0'],
        },
      ],
    },
    lpImage: bgRepeatlp,
    contentMap2: [
      {
        imageTop: require('../../assets/svg/bg-repeat-img1.svg'),
        header: 'Easy one time setup',
        subHeader:
          'Take one-time mandate and auto debit customer whenever the payment is due. No second factor authentication needed.',
        buttonText: 'Simplify Experience',
        uri: 'experience',
      },
      {
        imageTop: require('../../assets/svg/bg-repeat-img2.svg'),
        header: 'Auto recurring payments',
        subHeader:
          'Set the billing frequency (daily, weekly, monthly) during mandate and let JioPay collect transactions on recurring basis',
      },
      {
        imageTop: require('../../assets/svg/bg-repeat-img3.svg'),
        header: 'Eliminate ambiguity',
        subHeader:
          'Reduce the risk of doing business with the reassurance of payments being made on time basis your billing cycle setting',
      },
    ],
    advantage:
      'Increase lifetime value (LTV), loyalty and offer convenience by letting users pay automatically. Complete Control.',
    idealFor: 'A business that would want their users to make cyclic, frictionless payments and mitigate risk.',
  },
  paycollect: {
    id: 'Collect',
    lpImage: require('../../assets/images/individual-product/collect/collect-icon.png'),
    headerRight: '',
    header: 'Sell. Fulfil. Collect.',
    subHeader: 'Generate payment collection links on-demand and increase customer trust',
    headerImage: collectHeaderImg,
    stats: [
      {
        id: 0,
        icon: 'FUND_TRANSFER',
        title: '300 Million+',
        subTitle: 'Transactions processed',
      },
      {
        id: 1,
        icon: 'SHOP',
        title: '100K+',
        subTitle: 'Unique merchants',
      },
      {
        id: 2,
        icon: 'TOKEN',
        title: '7 Million+',
        subTitle: 'Cards tokenized',
      },
    ],
    checkListheader: 'Control payment collection for your business',
    checkList: {
      leftColumn: [
        {
          id: '1',
          component: MobileCard,
          title: 'Digitize payment on delivery',
          bg: ['#E6DBFF', '#FFE8F9'],
        },
        {
          id: '2',
          icon: 'INVOICES',
          title: 'Manage invoices',
          bg: ['#D9FFE7', '#D5F1FF'],
        },
        {
          id: '3',
          icon: 'ADD_USER',
          title: 'Increase user retention',
          bg: ['#FFDEE2', '#FFEFF1'],
        },
      ],
      rightColumn: [
        {
          id: '1',
          icon: 'STATUS_AWAITING',
          title: 'Scheduled payment collection',
          bg: ['#BCD4FF', '#D9F5FF'],
        },
        {
          id: '2',
          icon: 'CUSTOMIZE',
          title: 'Customizable experiences',
          bg: ['#FFF8EF', '#FFDBD0'],
        },
      ],
    },
    contentMap2: [
      {
        imageTop: bgCollect1,
        header: 'Create links instantly',
        subHeader: 'Decide when and how to initiate payment links to get paid by your users',
      },
      {
        imageTop: bgCollect2,
        header: 'GST compliant invoices',
        subHeader: 'Decide to initiate the payment with an optional GST compliant invoice',
      },
      {
        imageTop: bgCollect3,
        header: 'Customized Experiences',
        subHeader: 'Decide payment schedule, track receivables and send reminders for dues',
      },
    ],
    advantage:
      'Increase customer trust by generating payment collection links after fulfilment. Digitization across lifecycle.',
    idealFor:
      'Businesses wanting to collect payment remotely (COD), facilitate deferred payments and offer flexibility',
  },
  paycampaign: {
    id: 'Campaign',
    header: 'Configure. Transact. Reward.',
    subHeader: 'Run diverse offers and increase engagement',
    headerImage: campaignHeader,
    isFullWidth: true,
    checkListheader: 'Run offers that are relevant to your users',
    stats: [
      {
        id: 0,
        icon: 'FUND_TRANSFER',
        title: '300 Million+',
        subTitle: 'Transactions processed',
      },
      {
        id: 1,
        icon: 'SHOP',
        title: '100K+',
        subTitle: 'Unique merchants',
      },
      {
        id: 2,
        icon: 'TOKEN',
        title: '7 Million+',
        subTitle: 'Cards tokenized',
      },
    ],
    checkList: {
      leftColumn: [
        {
          id: '1',
          component: Offer,
          title: 'Payment method based offers',
          bg: ['#E6DBFF', '#FFE8F9'],
        },
        {
          id: '2',
          icon: 'SETTLEMENTS',
          title: 'Personalise basis products',
          bg: ['#D9FFE7', '#D5F1FF'],
        },
        {
          id: '3',
          imgUrl: require('../../assets/svg/trendingup-graph.svg'),
          title: 'Increase business',
          bg: ['#FFDEE2', '#FFEFF1'],
        },
      ],
      rightColumn: [
        {
          id: '1',
          icon: 'SETTING',
          title: 'Multiple configurations',
          bg: ['#BCD4FF', '#D9F5FF'],
        },
        {
          id: '2',
          component: Controls,
          title: 'Superior control',
          bg: ['#FFF8EF', '#FFDBD0'],
        },
        {
          id: '3',
          icon: 'INSIGHTS',
          title: 'Relevant and data-based',
          bg: ['#FFF8EF', '#FFDBD0'],
        },
      ],
    },
    lpImage: require('../../assets/svg/campaignHeaderIcon.svg'),
    contentMap2: [
      {
        imageTop: require('../../assets/svg/trendingup-graph-bg.svg'),
        header: 'Increase business',
        subHeader: 'Run offers to increase product adoption and sale',
      },
      {
        imageTop: require('../../assets/svg/winner-bg.svg'),
        header: 'Win-Win',
        subHeader: 'Personalise the offers basis your product catalogue and user base',
      },
      {
        imageTop: require('../../assets/svg/setting-bg.svg'),
        header: 'Configurable setup',
        subHeader: 'Configure relevant rewards and increase customer satisfaction',
      },
    ],
    advantage: 'Increase user engagement and transactions by incentivising users for their business with you.',
    idealFor: 'A business that would want to reward users for eligible transactions and grow business.',
  },
  mobileCheckout: {
    id: 'Checkout',
    header: 'Integrate. Personalise. Get paid.',
    subHeader: 'Create custom checkout pages and increase retention',
    headerImage: checkoutHeaderImg,
    stats: [
      {
        id: 0,
        icon: 'FUND_TRANSFER',
        title: '300 Million+',
        subTitle: 'Transactions processed',
      },
      {
        id: 1,
        icon: 'SHOP',
        title: '100K+',
        subTitle: 'Unique merchants',
      },
      {
        id: 2,
        icon: 'TOKEN',
        title: '7 Million+',
        subTitle: 'Cards tokenized',
      },
    ],
    checkListheader: 'Offer delightful payment experiences to your users',
    checkList: {
      leftColumn: [
        {
          id: '1',
          component: MobileCard,
          title: 'Device first experience',
          bg: ['#E6DBFF', '#FFE8F9'],
        },
        {
          id: '2',
          component: CardSettings,
          title: 'Personalised checkout',
          bg: ['#D9FFE7', '#D5F1FF'],
        },
        {
          id: '3',
          component: JioIcon,
          title: 'Experience JioPay suite',
          bg: ['#FFDEE2', '#FFEFF1'],
        },
      ],
      rightColumn: [
        {
          id: '1',
          component: Templates,
          title: 'Choice of templates',
          bg: ['#BCD4FF', '#D9F5FF'],
        },
        {
          id: '2',
          imgUrl: require('../../assets/svg/easy_integration.svg'),
          title: '1 time integration',
          bg: ['#FFF8EF', '#FFDBD0'],
        },
        {
          id: '2',
          component: Star,
          title: 'Superior experience',
          bg: ['#F5EFC9', '#FFFFE2'],
        },
      ],
    },
    lpImage: mobile,
    contentMap2: [
      {
        component: MobileCardBg,
        header: 'Simple & fast payments',
        subHeader:
          'Mobile Checkout offers a device-first experience for your users to make payments quickly and easily fro any device',
      },
      {
        component: SettlementsBg,
        header: 'Consistent experience',
        subHeader: 'Customise the checkout page basis your product and brand theme so that your users feel at home',
        uri: 'experience',
      },
      {
        imageTop: mobChTop3,
        header: '1 time integration',
        subHeader: 'Integrate once, decide payment methods and let JioPay manage payments for you',
        uri: 'experience',
      },
    ],
    advantage: 'Increase the retention rate by offering a simple and brand-familiar payment experience.',
    idealFor: 'Any business that would want to make payments simple and intuitive for their users.',
  },
  vault: {
    id: 'Vault',
    header: 'Transact. Tokenize. Grow.',
    subHeader: 'Tokenize cards compliantly for seamless future transactions',
    headerImage: vaultHeaderImg,
    stats: [
      {
        id: 0,
        icon: 'FUND_TRANSFER',
        title: '300 Million+',
        subTitle: 'Transactions processed',
      },
      {
        id: 1,
        icon: 'SHOP',
        title: '100K+',
        subTitle: 'Unique merchants',
      },
      {
        id: 2,
        icon: 'TOKEN',
        title: '7 Million+',
        subTitle: 'Cards tokenized',
      },
    ],
    checkListheader: 'Tokenize cards and offer easy checkout for your repeat users',
    checkList: {
      leftColumn: [
        {
          id: '1',
          component: MobileCard,
          title: 'Compliant method',
          bg: ['#E6DBFF', '#FFE8F9'],
        },
        {
          id: '2',
          component: CardSettings,
          title: 'Zero disruption',
          bg: ['#D9FFE7', '#D5F1FF'],
        },
      ],
      rightColumn: [
        {
          id: '1',
          imgUrl: require('../../assets/svg/easy_integration.svg'),
          title: 'One integration',
          bg: ['#BCD4FF', '#D9F5FF'],
        },
        {
          id: '2',
          imgUrl: require('../../assets/svg/trending_up.svg'),
          title: 'Increase conversions',
          bg: ['#F5EFC9', '#FFFFE2'],
        },
      ],
    },
    lpImage: require('../../assets/images/individual-product/vault/vault.png'),
    contentMap2: [
      {
        component: VaultTokensBg,
        header: 'Compliant to new norms',
        subHeader: 'Our vault uses tokenization that is compliant to updated RBI norms and guidelines',
      },
      {
        imageTop: mobChTop3,
        header: 'One time integration',
        subHeader: 'Integrate once to manage tokenization across multiple card networks',
        uri: 'experience',
      },
      {
        imageTop: bgDirect2,
        header: 'Increase Conversions',
        subHeader: 'Increase success rates and user revisits while offering seamless experience',
        uri: 'experience',
      },
    ],
    advantage:
      'Reduce transaction time and increase conversion rate by reducing friction at checkout while being compliant',
    idealFor: 'Any business that wants to simplify payments experience for their users',
  },
  console: {
    id: 'Console',
    header: 'Sell. Monitor. Optimize.',
    subHeader: 'Run diverse offers and increase engagement',
    headerImage: consoleHeader,
    isFullWidth: true,
    stats: [
      {
        id: 0,
        icon: 'FUND_TRANSFER',
        title: '300 Million+',
        subTitle: 'Transactions processed',
      },
      {
        id: 1,
        icon: 'SHOP',
        title: '100K+',
        subTitle: 'Unique merchants',
      },
      {
        id: 2,
        icon: 'TOKEN',
        title: '7 Million+',
        subTitle: 'Cards tokenized',
      },
    ],
    checkListheader: 'Operate your business seamlessly and make the right choices',
    checkList: {
      leftColumn: [
        {
          id: '1',
          icon: 'INSIGHTS',
          title: 'Information insights',
          bg: ['#E6DBFF', '#FFE8F9'],
        },
        {
          id: '2',
          icon: 'HAMBURGER_OPTIONS',
          title: 'Instant access to features',
          bg: ['#D9FFE7', '#D5F1FF'],
        },
      ],
      rightColumn: [
        {
          id: '1',
          component: Controls,
          title: 'Operate seamlessly',
          bg: ['#BCD4FF', '#D9F5FF'],
        },
        {
          id: '2',
          imgUrl: require('../../assets/svg/trending_up.svg'),
          title: 'Monitor critical metrics',
          bg: ['#F5EFC9', '#FFFFE2'],
        },
      ],
    },
    headerIcon: 'INSIGHTS',
    contentMap2: [
      {
        imageTop: require('../../assets/svg/trendingup-graph-bg.svg'),
        header: 'Grow your business',
        subHeader: 'Learn from critical information that is processed from your valuable data',
      },
      {
        component: InsightsBg,
        header: 'Data & Reports',
        subHeader: 'View and download operational reports instantly to manage your business easily',
      },
      {
        component: ProductsBg,
        header: 'Access to products',
        subHeader: 'Easy access to product features for a complete self-help experience',
      },
    ],
    advantage: 'Increase your productivity by accessing business performance data and features on-demand as needed',
    idealFor: 'All businesses to analyse data and JioPay Products',
  },
  oneqr: {
    id: '1 QR',
    header: 'Sell. Display. Get Paid.',
    subHeader: 'Run diverse offers and increase engagement',
    headerImage: qrHeader,
    stats: [
      {
        id: 0,
        icon: 'FUND_TRANSFER',
        title: '300 Million+',
        subTitle: 'Transactions processed',
      },
      {
        id: 1,
        icon: 'SHOP',
        title: '100K+',
        subTitle: 'Unique merchants',
      },
      {
        id: 2,
        icon: 'TOKEN',
        title: '7 Million+',
        subTitle: 'Cards tokenized',
      },
    ],
    checkListheader: 'Multiply your business with new-age UPI products',
    checkList: {
      leftColumn: [
        {
          id: '1',
          icon: 'SCAN_QR',
          title: 'Versatile QR solutions',
          bg: ['#E6DBFF', '#FFE8F9'],
        },
        {
          id: '2',
          imgUrl: require('../../assets/svg/mobile-desktop.svg'),
          title: 'Omnichannel capabilities',
          bg: ['#D9FFE7', '#D5F1FF'],
        },
      ],
      rightColumn: [
        {
          id: '1',
          icon: 'REFUNDS',
          title: 'Smart reconciliation',
          bg: ['#BCD4FF', '#D9F5FF'],
        },
        {
          id: '2',
          imgUrl: require('../../assets/svg/trendingup-graph.svg'),
          title: 'Grow business exponentially',
          bg: ['#F5EFC9', '#FFFFE2'],
        },
      ],
    },
    headerIcon: 'SCAN_QR',
    contentMap2: [
      {
        component: QrBg,
        header: 'Smart Collection',
        subHeader: 'Leverage 1 QR to enable collection from diverse payment methods with a single QR',
      },
      {
        component: RefundsBg,
        header: 'Easy Reconciliation',
        subHeader: 'Simplify your operations with automatic reconciliation via dynamic QRs',
      },
      {
        imageTop: require('../../assets/svg/trendingup-graph-bg.svg'),
        header: 'Increase business',
        subHeader: 'Unbox the JioPay suite of UPI products for smart and easy collection',
      },
    ],
    advantage:
      'Collect payment digitally after service fulfilment, reconcile automatically and accept digital payments with little or no development.',
    idealFor:
      'Businesses who want to digitise COD, merchants who want to allow QR payments with automatic reconciliation from all UPI apps.',
  },
  voicebox: {
    id: 'Voice Box',
    header: 'Real-time. Voice Alerts. Premium Benefits',
    subHeader: 'The only speaker your business needs!',
    headerImage: voiceBoxHeader,
    stats: [
      {
        id: 0,
        component: MultiLanguage,
        title: 'Alerts in 6 regional languages',
        subTitle: '',
      },
      {
        id: 1,
        component: Battery,
        title: 'Superior Battery Life',
        subTitle: '',
      },
      {
        id: 2,
        component: Sim,
        title: '4G high-speed connectivity',
        subTitle: '',
      },
    ],
    checkListheader: 'Not just payment alerts',
    checkList: {
      leftColumn: [
        {
          id: '1',
          component: OfferCampaign,
          title: 'Instant multilingual payment alerts',
          bg: ['#E6DBFF', '#FFE8F9'],
        },
        {
          id: '2',
          component: Settlements,
          title: 'Smartphone app to control VoiceBox',
          bg: ['#D9FFE7', '#D5F1FF'],
        },
        {
          id: '3',
          imgUrl: require('../../assets/svg/innovate_at_scale.svg'),
          title: 'Superior battery life',
          bg: ['#D9FFE7', '#D5F1FF'],
        },
      ],
      rightColumn: [
        {
          id: '1',
          component: Settlements,
          title: 'Reliable for noisy outdoor use',
          bg: ['#BCD4FF', '#D9F5FF'],
        },
        {
          id: '2',
          component: Settlements,
          title: '4G high-speed network connectivity',
          bg: ['#F5EFC9', '#FFFFE2'],
        },
      ],
    },
    headerIcon: 'MIC',
    contentMap2: [
      {
        component: empower,
        header: 'Empower your staff',
        subHeader: `Voice alerts for shop staff in the owner's absence.`,
      },
      {
        component: Settings,
        header: 'Seamless experience',
        subHeader: 'Eliminate the need to check your phone or the customers',
      },
      {
        component: ArrowWithBg,
        header: 'On-the-go payments',
        subHeader: 'Receive instant audio alerts via the Android app.',
      },
    ],
    advantage: 'Seamless multilingual audio payment alerts, even in noisy environments.',
    idealFor: 'Shop owners seeking an affordable voice-based payment solution.',
  },
}
